// extracted by mini-css-extract-plugin
export default {"indicator":"indicator_indicator__CWnJc"};